import React from 'react';
import { Link } from 'react-router-dom';

const base =
  'group inline-flex items-center justify-center gap-2 rounded-lg font-medium whitespace-nowrap transition-[background-color,box-shadow,color,transform] duration-300 ease-[cubic-bezier(.16,1,.3,1)] active:translate-y-px';

const variants = {
  primary: 'bg-grovv text-ink shadow-pill hover:-translate-y-px hover:bg-grovv-400 hover:shadow-[inset_0_-2px_0_rgba(15,34,54,.18),0_10px_24px_-10px_rgba(77,166,38,.7)]',
  secondary: 'bg-white text-ink ring-1 ring-inset ring-fog-300 hover:ring-ink-500',
  dark: 'bg-ink text-white hover:bg-navy-700',
  onDark: 'bg-white/10 text-white ring-1 ring-inset ring-white/25 hover:bg-white/15',
};

const sizes = {
  md: 'min-h-[44px] px-5 text-[0.95rem]',
  lg: 'min-h-[52px] px-7 text-base',
};

export function Arrow({ className = '' }) {
  return (
    <svg
      className={`h-4 w-4 shrink-0 transition-transform duration-300 ease-[cubic-bezier(.16,1,.3,1)] group-hover:translate-x-0.5 rtl:-scale-x-100 rtl:group-hover:-translate-x-0.5 ${className}`}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 12h14" />
      <path d="M13 6l6 6-6 6" />
    </svg>
  );
}

export default function Button({ to, href, variant = 'primary', size = 'md', arrow = false, className = '', children, ...rest }) {
  const classes = `${base} ${variants[variant]} ${sizes[size]} ${className}`;
  const content = (
    <>
      {children}
      {arrow && <Arrow />}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {content}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <button className={classes} {...rest}>
      {content}
    </button>
  );
}
